export default __webpack_public_path__ + "static/media/Tech-Blog-img-2.30702cb1.gif";